import {
  AppShell,
  Burger,
  Group,
  NavLink,
  ScrollArea,
  Text,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { IconActivity, IconFlask, IconHome } from "@tabler/icons-react";
import { useMemo } from "react";
import { AppErrorBoundary } from "../components/AppErrorBoundary";

const NAV_ITEMS = [
  { label: "Dashboard", to: "/", icon: IconHome },
  { label: "Experiments", to: "/experiments", icon: IconFlask },
  { label: "Recommendations", to: "/recommendations", icon: IconActivity },
];

export function AppLayout(): JSX.Element {
  const [opened, { toggle, close }] = useDisclosure(false);
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = useMemo(
    () =>
      NAV_ITEMS.map((item) => ({
        ...item,
        active: location.pathname === item.to,
      })),
    [location.pathname],
  );

  return (
    <AppShell
      header={{ height: 64 }}
      navbar={{
        width: 260,
        breakpoint: "sm",
        collapsed: { mobile: !opened },
      }}
      padding="lg"
    >
      <AppShell.Header>
        <Group h="100%" px="md" justify="space-between">
          <Group gap="sm">
            <Burger
              opened={opened}
              onClick={toggle}
              hiddenFrom="sm"
              size="sm"
            />
            <Text fw={700}>HealthHub Research Platform</Text>
          </Group>
          <Text size="sm" c="dimmed">
            HIPAA-aligned research sandbox
          </Text>
        </Group>
      </AppShell.Header>

      <AppShell.Navbar p="md">
        <AppShell.Section grow component={ScrollArea}>
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              label={item.label}
              leftSection={<item.icon size={18} />}
              active={item.active}
              onClick={() => {
                navigate(item.to);
                close();
              }}
            />
          ))}
        </AppShell.Section>
      </AppShell.Navbar>

      <AppShell.Main>
        <AppErrorBoundary fallbackTitle="Dashboard rendering error">
          <Outlet />
        </AppErrorBoundary>
      </AppShell.Main>
    </AppShell>
  );
}
